// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActiveSessionWarningController from "./active_session_warning_controller"
application.register("active-session-warning", ActiveSessionWarningController)

import AgentCallNavController from "./agent_call_nav_controller"
application.register("agent-call-nav", AgentCallNavController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import CallController from "./call_controller"
application.register("call", CallController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChatFormController from "./chat_form_controller"
application.register("chat-form", ChatFormController)

import ConfirmDialogController from "./confirm_dialog_controller"
application.register("confirm-dialog", ConfirmDialogController)

import DraftNoticeController from "./draft_notice_controller"
application.register("draft-notice", DraftNoticeController)

import FieldDraftController from "./field_draft_controller"
application.register("field-draft", FieldDraftController)

import ChatMessageClassController from "./chat_message_class_controller"
application.register("chat-message-class", ChatMessageClassController)

import ChatMessageController from "./chat_message_controller"
application.register("chat-message", ChatMessageController)

import ChatMessageMarkAsSeenController from "./chat_message_mark_as_seen_controller"
application.register("chat-message-mark-as-seen", ChatMessageMarkAsSeenController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import OnlineAgentsController from "./online_agents_controller"
application.register("online-agents", OnlineAgentsController)

import ReloadController from "./reload_controller"
application.register("reload", ReloadController)

import RequestTypeSelectorController from "./request_type_selector_controller"
application.register("request-type-selector", RequestTypeSelectorController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import StatusConfirmController from "./status_confirm_controller"
application.register("status-confirm", StatusConfirmController)

import ServiceCenterController from "./service_center_controller"
application.register("service-center", ServiceCenterController)

import ServiceRequestAttachmentsController from "./service_request_attachments_controller"
application.register("service-request-attachments", ServiceRequestAttachmentsController)

import ServiceRequestFormController from "./service_request_form_controller"
application.register("service-request-form", ServiceRequestFormController)

import ZoomController from "./zoom_controller"
application.register("zoom", ZoomController)
